"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAvatarBadge = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AvatarBadgeMixin = require("../../mixins/components/AvatarBadgeMixin");
var StyledAvatarBadge = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledAvatarBadge",
  componentId: "c11n-8-107-0__sc-1j91ypt-0"
})(["", ""], _AvatarBadgeMixin.AvatarBadgeMixin);
exports.StyledAvatarBadge = StyledAvatarBadge;